import 'css-chunksrc/client/scenes/documentCreation/form/folderSelection/folder/styles.scss';export default {
  "projectIcon": "_projectIcon_1kpt0_1",
  "folderIcon": "_folderIcon_1kpt0_7",
  "name": "_name_1kpt0_12",
  "selected": "_selected_1kpt0_24"
};